import React, { Component,cloneElement } from 'react';
import {
    List, Edit, Datagrid, TextField, ReferenceField, Button, ReferenceInput, EditButton, GET_ONE,
    DateField, AutocompleteInput, SelectInput, Toolbar, SaveButton, SimpleForm, Filter, useRecordContext, useTranslate,
    DateInput,
    RefreshButton,
    TopToolbar,
    useResourceContext,
    CreateButton,
} from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import Modal from 'react-responsive-modal';
// import DateFnsUtils from '@date-io/date-fns';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
// import mwLocale from "date-fns/locale/en_MW";
import myDataProvider from '../../src/myRestProvider';
// import { DateInput } from 'react-admin-date-inputs';
import noImage from './../images/combined-shape.svg';
import moment from 'moment';
import { CREATE } from 'ra-core';
import { getLocalStorageKey } from '../common/common';
import { useLocation } from 'react-router-dom';


// class PostPanel extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             open: false,
//         };
//     }

//     onOpenModal = () => {
//         console.log('open',this.props);
//         this.setState({ open: true})
//     };

//     onCloseModal = () => {
//         console.log(this.state.open);
//         this.setState({ open: false });
//     };
//     render(){
//         const { open } = this.state;
//         const {props} = this;
//         const fileData = JSON.parse(props.imageDetails);
//         const fileType = fileData.file_type;
//         let imagePath =this.props.imageDetails.split('.');
//         imagePath = imagePath[imagePath.length - 1];
//         return(
//         <div>
//             {
//             <div>
//                 <a className="list-img" >
//                 { fileType === 'image' ?
//                     <img onClick={this.onOpenModal} src={fileData.file_data} />:
//                     <img src={noImage} />
//                 }
//                 </a>
//                 <Modal open={open} onClose={this.onCloseModal}>
//                     <div className="image-large-view">
//                         { fileType === 'image' ?
//                             <img src= {fileData.file_data} />:
//                             <img src= {noImage} />
//                         }
//                     </div>
//                 </Modal>
//             </div>
//             }
//         </div>
//         )
//     }
// }

const PostPanel = (props) => {
    const [open, setOpen] = React.useState(false)

    const onOpenModal = () => {
        console.log('open', props);
        setOpen(true);
    };

    const onCloseModal = () => {
        console.log(open);
        setOpen(false);
    };

    const fileData = JSON.parse(props.imageDetails);
    const fileType = fileData.file_type;
    let imagePath = props.imageDetails.split('.');
    imagePath = imagePath[imagePath.length - 1];
    return (
        <div>
            {
                open ?
                    <div>
                        <a className="list-img" >
                            {fileType === 'image' ?
                                <img onClick={onOpenModal} src={fileData.file_data} /> :
                                <img src={noImage} />
                            }
                        </a>
                        <Modal open={open} onClose={onCloseModal}>
                            <div className="image-large-view">
                                {fileType === 'image' ?
                                    <img src={fileData.file_data} /> :
                                    <img src={noImage} />
                                }
                            </div>
                        </Modal>
                    </div>
                    :
                    <a className="list-img" >
                        {fileType === 'image' ?
                            <img onClick={onOpenModal} src={fileData.file_data} /> :
                            <img src={noImage} />
                        }
                    </a>
            }
        </div>
    )
}


const  DownloadTag =(props)=> {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         fileURL: null,
    //     };
    //     // console.log("props >>>>", props);
    // }
    const translate = useTranslate();


   const sendImageData = () => {
        console.log("props >>>>", props);
        const fileData = JSON.parse(props.fileDetails);
        console.log('fileData', fileData.file_id);

        myDataProvider(CREATE, '/proof_of_payment/download_file', { data: { file_id: fileData.file_id } })
            .then(json => {
                if (json.data.status === 'success') {
                    window.open(json.data?.file_url, '_blank');
                }
            })
            .catch(error => console.log('error', error));
    }
    
        return (
            <div className="download-button" onClick={sendImageData}>{translate('resources.proof_of_payments.fields.download')}</div>

        )
    

}

const StatusField = ({ source }) => {
    const record = useRecordContext();
    return (
        <span>{record[source] === null ? '-' : record[source] ? 'Yes' : 'No'}</span>
    )
}

const selectInputStyle = {
    width: 200,
};

const PostFilter = (props) => {
    const proofOfPaymentForm = getLocalStorageKey('proof_of_payment_form');
    const showOrderNumber = proofOfPaymentForm && proofOfPaymentForm.order_number.show;
    const showModeOfPayment = proofOfPaymentForm && proofOfPaymentForm.mode_of_payment.show;
    const modeOfPaymentChoice = showModeOfPayment &&
        Object.keys(proofOfPaymentForm.mode_of_payment.values).map(item => { return { id: item, name: item } });
    return (
        <Filter {...props}>
            <DateInput source="created_at" 
            // label="Uploaded date from" 
            />
            <DateInput source="uploaded_date_to" 
            // label="Uploaded date to"
             />
            <ReferenceInput
            //  label="Sold To" 
            source="business_id" reference="businesses" linkType="show" allowEmpty>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            {
                showOrderNumber &&
                <ReferenceInput 
                // label="Order Number" 
                source="sap_digital_order_id" reference="sap_digital_orders" linkType="show" allowEmpty>
                    <AutocompleteInput optionText="order_number" />
                </ReferenceInput>
            }

            {
                showModeOfPayment &&
                <SelectInput style={selectInputStyle} source="mode_of_payment"  choices={modeOfPaymentChoice} />
            }

            <SelectInput style={selectInputStyle} source="approved"  choices={[
                { id: true, name: 'Yes' },
                { id: false, name: 'No' },
            ]} />
        </Filter>
    )
}

const styles = {
    image: {
        height: 50,
        width: 50,
    },
}
const CreateDownloadButton = () => {
    const record = useRecordContext();

    return (<Button
    >
        <div>
            <DownloadTag fileDetails={record?.file_url_data}></DownloadTag>
            {/* <a className="download-button" href={record.file_url} target = '_blank'>Download</a> */}
        </div>
    </Button>)
}

const ImageShow = () => {
    const record = useRecordContext();
    console.log('records', record);

    return (
        <div>
            <PostPanel imageDetails={record.file_url_data}></PostPanel>
        </div>)
}


const EditToolbar = (props) => (
    <Toolbar {...props} >
        <SaveButton alwaysEnable />
    </Toolbar>
);

const ListActions = (props) => {
    const location = useLocation();
    const resource = useResourceContext();
  
  
    const {
      filterValues,
      total,
      maxResults,
      currentSort,
      exporter,
      permanentFilter,
      showFilter,
      displayedFilters,
      filters,
      basePath,
    } = props;
    const csvResource = resource + "_csv";
    return (
      <>
        <TopToolbar>
          {filters &&
            cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: "button",
            })}
          <CreateButton basePath={basePath} />
          <RefreshButton />
        </TopToolbar>
      </>
    );
  }


export const PostList = props => {
    const proofOfPaymentForm = getLocalStorageKey('proof_of_payment_form');
    const showOrderNumber = proofOfPaymentForm && proofOfPaymentForm.order_number.show;
    const showModeOfPayment = proofOfPaymentForm && proofOfPaymentForm.mode_of_payment.show;
    const translate = useTranslate();

    const CustomDateTimeField = ({ source }) => {
        const record = useRecordContext();
        const date = record[source] ? new Date(record[source]) : null;
        const formattedDate = date ? date.toLocaleDateString('en-GB') : '';
        const formattedTime = date ? date.toLocaleTimeString() : '';
      
        return (
          <span>
            {formattedDate}, {formattedTime}
          </span>
        );
      };
      

    return (
        <Scrollbars className="scroll-container">
            <List {...props} filters={<PostFilter />} actions={<ListActions />} sort={{ field: 'created_at', order: 'DESC' }} title={translate('resources.proof_of_payments.fields.file_url_data')}  exporter={false}>
                <Datagrid bulkActionButtons={false}>
                    <CustomDateTimeField source="created_at" showTime />
                    {/* <DateField source="created_at" label="Upload Timestamp" showTime /> */}
                    <ReferenceField source="business_id" reference="businesses" link="show" allowEmpty>
                        <TextField source="sap_code" />
                    </ReferenceField>
                    {
                        showOrderNumber &&
                        <ReferenceField source="sap_digital_order_id" reference="sap_digital_orders" link="show" allowEmpty>
                            <TextField source="order_number" />
                        </ReferenceField>
                    }
                    {
                        showModeOfPayment &&
                        <TextField source="mode_of_payment" />
                    }
                    {/* <ReferenceField source="business_name" reference="businesses" link="show" allowEmpty> */}
                        <TextField source="business_name" />
                    {/* </ReferenceField> */}
                    <StatusField source="approved" />
                    <EditButton source="edit" />
                    <ImageShow source="file_url_data" className={styles.image} />
                    <CreateDownloadButton source="download" />
                </Datagrid>
            </List>
        </Scrollbars>
    );
}

export const PostEdit = ({ permissions, ...props }) => (
    <Edit  {...props} undoable={false}>
        <SimpleForm toolbar={<EditToolbar />}>
            {/* <DateInput source="created_at" label="Upload Timestamp" showTime /> */}
            <SelectInput selected='name' source="approved" label="Account Credited" choices={[
                { id: true, name: 'Yes' },
                { id: false, name: 'No' },
            ]}
                defaultValue="approved" />
        </SimpleForm>
    </Edit>
);

